/** Shared merge helpers for opt-in HITL detail fixtures (handoff, break glass, …). */

export function isEmptyFixtureValue(value) {
  if (value == null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
}

/**
 * @param {Record<string, unknown>} detail
 * @param {Record<string, unknown>} fixture
 * @param {Record<string, 'replaceIfEmpty' | 'mergeObject'>} [keyRules]
 */
export function mergeFixtureDetail(detail = {}, fixture = {}, keyRules = {}) {
  const merged = { ...detail };

  for (const [key, value] of Object.entries(fixture)) {
    const rule = keyRules[key] ?? 'replaceIfEmpty';

    if (rule === 'mergeObject') {
      merged[key] = { ...(value ?? {}), ...(merged[key] ?? {}) };
      for (const [nestedKey, nestedValue] of Object.entries(value ?? {})) {
        if (isEmptyFixtureValue(merged[key][nestedKey])) {
          merged[key][nestedKey] = nestedValue;
        }
      }
      continue;
    }

    if (isEmptyFixtureValue(merged[key])) {
      merged[key] = value;
    }
  }

  return merged;
}

/** True when `detail` is missing any field the fixture would supply. */
export function isDetailMissingFixtureFields(detail = {}, fixture = {}, keyRules = {}) {
  for (const [key, fixtureValue] of Object.entries(fixture)) {
    if (isEmptyFixtureValue(fixtureValue)) continue;

    const rule = keyRules[key] ?? 'replaceIfEmpty';

    if (rule === 'mergeObject') {
      if (isEmptyFixtureValue(detail[key])) return true;
      for (const [nestedKey, nestedValue] of Object.entries(fixtureValue ?? {})) {
        if (isEmptyFixtureValue(nestedValue)) continue;
        if (isEmptyFixtureValue(detail[key]?.[nestedKey])) return true;
      }
      continue;
    }

    if (isEmptyFixtureValue(detail[key])) return true;
  }

  return false;
}
